export const getPathPrefix = (path: string, levelsUp: number, delimiter = ".") => {
	const fragments = path.split(delimiter);
	return fragments.slice(0, fragments.length - levelsUp).join(delimiter);
};
